import { useCallback } from 'react';
import { ClbModal } from '@celebration/react/ClbModal/ClbModal';
import { useTranslation } from 'react-i18next';
import {
    ButtonPropsModal,
    ItemsFooterType,
} from '@celebration/react/ClbModal/ClbModal.types';
import IErrorModal from './interfaces/IErrorModal';

function ErrorModal({
    isOpen,
    title,
    description,
    onClose,
}: Readonly<IErrorModal>) {
    const { t } = useTranslation();

    const handleClose = useCallback(() => {
        onClose();
    }, [onClose]);

    const closeButton: ButtonPropsModal = {
        key: 'close-button',
        id: 'close-button',
        label: t('Fechar'),
        disabled: false,
        loading: false,
        title: t('Fechar'),
        'data-testid': 'error-modal-close-button',
        onClick: handleClose,
        role: 'button',
        size: 'md',
        styleType: 'danger',
    };

    const buttonsModal: ItemsFooterType = [closeButton];

    return (
        <ClbModal
            title={title}
            open={isOpen}
            onClose={handleClose}
            description={description}
            type="danger"
            itemsFooter={buttonsModal}
            data-testid="error-modal"
        />
    );
}

export default ErrorModal;
